// ShippingPolicy.jsx
import React from "react";
import {
  FaBox,
  FaCalendarAlt,
  FaClock,
  FaTag,
  FaBan,
  FaMoneyBillWave,
  FaExchangeAlt,
  FaQuestionCircle,
  FaGlobe,
  FaFlag,
} from "react-icons/fa";
import "../styles/ShippingPolicy.css";

const ShippingPolicy = () => {
  return (
    <div className="shipping-policy-container">
      <div className="policy-header">
        <h1>
          <FaBox style={{ marginRight: "8px" }} />
          Shipping & Delivery Policy
        </h1>
        <p>KKB — Tradition through Generations</p>
        <span className="badge">Lungies • Towels • Bedsheets</span>
      </div>

      <div className="policy-content">
        {/* Section 1 */}
        <section className="policy-section">
          <h2>
            <FaCalendarAlt style={{ marginRight: "8px" }} />
            Why does the delivery date not correspond to the delivery timeline
            of X-Y business days?
          </h2>
          <p>
            It is possible that the Seller or our delivery partners have a
            holiday between the day you placed your order and the date of
            delivery, which is based on the timelines shown on the product page.
            In this case, we add a day to the estimated date. Some delivery
            partners and Sellers do not work on Sundays and this is factored in
            to the delivery dates.
          </p>
        </section>

        {/* Section 2 */}
        <section className="policy-section">
          <h2>
            <FaClock style={{ marginRight: "8px" }} />
            What is the estimated delivery time?
          </h2>
          <p>
            Sellers generally procure and ship the items within the time
            specified on the product page.{" "}
            <strong>Business days exclude public holidays and Sundays.</strong>
          </p>
          <p>Estimated delivery time depends on the following factors:</p>
          <ul>
            <li>The Seller offering the product</li>
            <li>Product's availability with the Seller</li>
            <li>
              The destination to which you want the order shipped to and
              location of the Seller
            </li>
          </ul>
        </section>

        {/* Section 3 */}
        <section className="policy-section">
          <h2>
            <FaTag style={{ marginRight: "8px" }} />
            Why does the estimated delivery time vary for each seller?
          </h2>
          <p>
            You have probably noticed varying estimated delivery times for
            sellers of the product you are interested in. Delivery times are
            influenced by product availability, geographic location of the
            Seller, your shipping destination and the delivery partner's
            time-to-deliver in your location.
          </p>
          <p className="highlight">
            Please enter your default pin code on the product page (you don't
            have to enter it every single time) to know more accurate delivery
            times on the product page itself.
          </p>
        </section>

        {/* Section 4 */}
        <section className="policy-section">
          <h2>
            <FaBan style={{ marginRight: "8px" }} />
            Seller does not/cannot ship to my area. Why?
          </h2>
          <p>
            Please enter your pincode on the product page to know whether the
            product can be delivered to your location. If you haven't provided
            your pincode until the checkout stage, the pincode in your shipping
            address will be used to check for serviceability.
          </p>
          <p>Whether your location can be serviced or not depends on:</p>
          <ul>
            <li>Whether the Seller ships to your location</li>
            <li>
              Legal restrictions, if any, in shipping particular products to
              your location
            </li>
            <li>
              The availability of reliable delivery partners in your location
            </li>
            <li>
              At times Sellers prefer not to ship to certain locations — this is
              entirely at their discretion.
            </li>
          </ul>
        </section>

        {/* Section 5 */}
        <section className="policy-section">
          <h2>
            <FaMoneyBillWave style={{ marginRight: "8px" }} />
            Why is the CoD option not offered in my location?
          </h2>
          <p>
            Availability of CoD depends on the ability of our delivery partner
            servicing your location to accept cash as payment at the time of
            delivery. Our delivery partners have limits on the cash amount
            payable on delivery depending on the destination and your order
            value might have exceeded this limit. Please enter your pin code on
            the product page to check if CoD is available in your location.
          </p>
        </section>

        {/* Section 6 */}
        <section className="policy-section">
          <h2>
            <FaExchangeAlt style={{ marginRight: "8px" }} />I need to return an
            item, how do I arrange for a pick-up?
          </h2>
          <p>
            Returns are easy. <strong>Contact Us</strong> to initiate a return.
            You will receive a call explaining the process, once you have
            initiated a return.
          </p>
          <p>
            Wherever possible, <strong>KKB Logistics</strong> will facilitate
            the pick-up of the item. In case the pick-up cannot be arranged, you
            can return the item through a third-party delivery service. Return
            fees are borne by the Seller.
          </p>
        </section>

        {/* Section 7 */}
        <section className="policy-section">
          <h2>
            <FaQuestionCircle style={{ marginRight: "8px" }} />I did not receive
            my order but got a delivery confirmation SMS/Email.
          </h2>
          <p>
            In case the product was not delivered and you received a delivery
            confirmation email/SMS,{" "}
            <strong>report the issue within 7 days</strong> from the date of
            delivery confirmation for the seller to investigate.
          </p>
        </section>

        {/* Section 8 */}
        <section className="policy-section">
          <h2>
            <FaGlobe style={{ marginRight: "8px" }} />
            Does KKB deliver internationally?
          </h2>
          <p>
            As of now,{" "}
            <strong>KKB does not deliver items internationally</strong>. You
            will be able to make your purchases on our site from anywhere in the
            world with credit/debit cards issued in India and 21 other
            countries, but please ensure the{" "}
            <strong>delivery address is in India</strong>.
          </p>
        </section>

        <div className="policy-footer">
          <p>
            <FaFlag style={{ marginRight: "8px" }} />
            KKB — Tradition through Generations | Lungies, Towels, Bedsheets
          </p>
          <p className="small">
            For any shipping-related queries, please contact our support team.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ShippingPolicy;
